import React from 'react';
import { Header } from '@/__core/layout';
import UnsavedChangesDialog from '@/__core/helpers/components/UnsavedChangesDialog';
import { TabData } from '@/__core/types/TabData';

interface ModuleTabsHeaderProps {
  tabs: TabData[];
  activeTab: number;
  currentTabType?: string;
  moduleType: 'users' | 'roles' | 'employees' | 'orders' | 'customers' | 'suppliers' | 'finance' | 'inventory' | 'timekeepings' | 'timesheets';
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  onCloseTab: (tabId: number) => void;
  onAddTab: () => void;
  unsavedDialog: {
    open: boolean;
    onClose: () => void;
    onConfirmLeave: () => void;
  };
}

export default function ModuleTabsHeader({
  tabs,
  activeTab,
  currentTabType,
  moduleType,
  onTabChange,
  onCloseTab,
  onAddTab,
  unsavedDialog,
}: ModuleTabsHeaderProps) {
  return (
    <>
      <Header
        tabs={tabs}
        activeTab={activeTab}
        currentTabType={currentTabType}
        onTabChange={onTabChange}
        onCloseTab={onCloseTab}
        onAddTab={onAddTab}
        moduleType={moduleType}
      />
      <UnsavedChangesDialog
        open={unsavedDialog.open}
        onClose={unsavedDialog.onClose}
        onConfirmLeave={unsavedDialog.onConfirmLeave}
      />
    </>
  );
}
